<template>
  <div>
    <px-banner-gestao/>
    <div class="px-5 mt-5">
      <v-row v-if="solicitacao">
        <v-col cols="12" sm="6">
          <span class="display-1 font-weight-bold">
            Solicitação de cotação
          </span><br>
          <span class="body-2">
            Código da cotação proxpect - {{ solicitacao.cotacao.id }}
          </span>
        </v-col>
        <v-col cols="12" sm="6" class="text-right body-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ solicitacao.fornecedor.pessoa.nome }}
                ( <px-fornecedor-documento :fornecedor="solicitacao.fornecedor"/>)
              </span>
            </template>
            <span>Empresa fornecedora</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>

    <div v-if="loading" class="text-center">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && solicitacao" class="mt-5">
      <div>
        <px-card-solicitacao-dados-basicos :solicitacao="solicitacao"
                                           :id-solicitacao="cotacaoId"
                                           @movimentar="onMovimentar"/>
      </div>
    </div>
    <div id="negociacoes">
      <px-negociacao v-if="!loading && isRespondida"
                     :resposta="solicitacao.respostaCotacao"
                     :cotacao-id="cotacaoId"
                     @movimentar="onMovimentar"/>
    </div>
    <v-row class="mt-5">
      <v-col cols="12">
        <px-aviso-plataforma-fornecedor-simple v-if="!loading && solicitacao"/>
      </v-col>
    </v-row>
    <px-auth-dialog v-model="showAuth"
                    :cotacao-id="cotacaoId"
                    @validate="onValidate"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import eventsMixin from '@/mixins/events-mixin';
import Negociacao from '@/modules/negociacao/Negociacao.vue';
import AcessosService from '@/api/acessos-service';
import { isNaN } from 'lodash';
import AuthDialog from './AuthDialog.vue';
import CardSolicitacaoDadosBasicos from './CardSolicitacaoDadosBasicos.vue';
import AuthService from './auth-service';
import SolicitacaoService from './solicitacao-service';

const recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
const REGISTRO_ACESSO_THRESHOLD_MINUTOS = 60;
const REGISTRO_ACESSO_KEY_PREFIX = 'acesso_registrado_';

export default {
  mixins: [eventsMixin],
  data() {
    return {
      showAuth: false,
      loading: false,
      solicitacao: null,
      receiver: this.$route.query.receiver,
    };
  },
  computed: {
    ...mapGetters({
      cotacaoId: 'cotacaoId',
      isAuthenticated: 'isAuthenticated',
      tokens: 'tokens',
    }),
    isRespondida() {
      return this.solicitacao && this.solicitacao.situacaoSolicitacaoResposta
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
  },
  methods: {
    async validate() {
      this.loading = true;
      try {
        const recaptchaToken = recaptchaKey ? await this.recaptcha() : undefined;
        await AuthService.validar(this.cotacaoId, {
          token: this.tokens, recaptcha: recaptchaToken,
        });
        await this.getSolicitacao();
      } catch (err) {
        this.showAuth = true;
      } finally {
        this.loading = false;
      }
    },
    verificarEnvioRegistroAcesso(key) {
      const ultimoRegistro = sessionStorage.getItem(key);

      if (!ultimoRegistro) {
        return true;
      }

      const dhUltimoRegistro = new Date(ultimoRegistro);
      if (isNaN(dhUltimoRegistro.getTime())) {
        sessionStorage.removeItem(key);
        return true;
      }

      const diffMinutos = (new Date() - dhUltimoRegistro) / 1000 / 60;
      return diffMinutos >= REGISTRO_ACESSO_THRESHOLD_MINUTOS;
    },
    registraAcesso() {
      if (!this.receiver) {
        return Promise.resolve();
      }

      const key = `${REGISTRO_ACESSO_KEY_PREFIX}${this.cotacaoId}`;
      const enviarRegistro = this.verificarEnvioRegistroAcesso(key);

      if (!enviarRegistro) {
        return Promise.resolve();
      }

      return AcessosService.registraAcesso(this.cotacaoId, {
        contato: this.receiver,
      })
        .then(() => {
          sessionStorage.setItem(key, new Date().toISOString());
        });
    },
    getSolicitacao() {
      return SolicitacaoService.getSolicitacao(this.cotacaoId)
        .then((response) => {
          this.solicitacao = response.data;
          this.createEventAccess(this.eventsResource.COTACAO,
            { solicitacao: this.cotacaoId }, true);
          return this.registraAcesso();
        });
    },
    onValidate() {
      this.loading = true;
      this.getSolicitacao()
        .finally(() => {
          this.loading = false;
        });
    },
    onMovimentar() {
      this.getSolicitacao();
    },
    async recaptcha() {
      await this.$recaptchaLoaded();
      return this.$recaptcha();
    },
  },
  async created() {
    if (!this.isAuthenticated) {
      this.showAuth = true;
      return;
    }
    await this.validate();
  },
  components: {
    pxAuthDialog: AuthDialog,
    pxCardSolicitacaoDadosBasicos: CardSolicitacaoDadosBasicos,
    pxNegociacao: Negociacao,
  },
};
</script>
